/** AI 标注 */
import { isArray } from "lodash";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import AiFootnoteTip from "./AIFootnoteTip";
import "./index.less";
import { sleep } from "@/utils/chat/message";
import { position } from "html2canvas/dist/types/css/property-descriptors/position";
interface IProps {
  message: any;
  [keys: string]: any;
}
interface ITipShowInfo {
  visible: boolean;
  position?: any;
}
function AiFootnote(props: IProps) {
  const { children, message } = props;
  const wrapRef = useRef<any>();
  const timeoutRef = useRef<any>();
  const tooltipRef = useRef<any>();
  const [selectData, setSelectData] = useState({});
  const [tipShowInfo, setTipShowInfo] = useState<ITipShowInfo>({
    visible: false,
    position: {}
  });

  // 参考数据
  const refsData = useMemo(() => {
    return isArray(message?.fullRefs) ? message?.fullRefs : [];
  }, [message]);

  const updateTipInfo = useCallback(
    (data: any) => {
      setTipShowInfo({
        ...tipShowInfo,
        ...data
      });
    },
    [tipShowInfo]
  );

  const clearData = useCallback(async () => {
    setSelectData({});
    updateTipInfo({
      visible: false,
      position: {}
    });
  }, [updateTipInfo]);

  // 鼠标移出
  const handleMouseLeave = useCallback(
    (e: any) => {
      timeoutRef.current = setTimeout(() => {
        if (!tooltipRef.current?.contains(document.activeElement)) {
          clearData();
        }
      }, 600);
    },
    [clearData]
  );

  const handleTipEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  // 鼠标移入
  const handleMouseOver = useCallback(
    async (ev: any) => {
      const content = ev?.target;
      const y = ev.clientY;
      const x = ev.clientX;
      if (!content) return;
      try {
        const attrIdx = content?.getAttribute("data-index");
        if (!attrIdx) {
          return;
        }
        const idx = Number(attrIdx);
        const data = refsData[idx];
        if (!data) {
          return;
        }
        setSelectData(data);
        updateTipInfo({
          visible: true,
          position: {
            top: y,
            left: x
          }
        });
      } catch (e) {
        console.error("handleMouseOver>error", e);
      }
    },
    [refsData, updateTipInfo]
  );

  const bindEvent = useCallback(() => {
    wrapRef.current?.querySelectorAll(".remark-footnote-ref")?.forEach((el: any) => {
      if (el) {
        el.addEventListener("mouseenter", handleMouseOver);
        el.addEventListener("mouseleave", handleMouseLeave);
      }
    });
  }, [handleMouseOver, handleMouseLeave]);

  const unBindEvent = useCallback(() => {
    wrapRef.current?.querySelectorAll(".remark-footnote-ref")?.forEach((el: any) => {
      if (el) {
        el.removeEventListener("mouseenter", handleMouseOver);
        el.removeEventListener("mouseleave", handleMouseLeave);
      }
    });
  }, [handleMouseOver, handleMouseLeave]);

  useEffect(() => {
    bindEvent();
    return () => {
      unBindEvent();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div ref={wrapRef} className="ai-footnote-wrap">
      <div ref={tooltipRef} className="ai-footer-tooltip-warp">
        <AiFootnoteTip
          dataInfo={selectData}
          visible={tipShowInfo?.visible}
          customStyle={tipShowInfo?.position}
          handleClose={clearData}
          handleEnter={handleTipEnter}
        />
      </div>
      {children}
    </div>
  );
}

export default AiFootnote;
